import Kfit from '../integrations/Kfit';
import Cookie from 'helpers/Cookie';

export default () => {
  const token = Cookie.get('accessToken');
  return Kfit.get(`/v1/rpp_qr_enabled`, token)
    .then(res => res)
    .catch(error => error);
};
